import React from "react";
import { Card, CardContent, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    color: "white",
  },
  cardTitleText: {
    marginLeft: theme.spacing(2),
  },
}));

export default function CardResultText({ title, data, icon, button }) {
  const classes = useStyles();
  
  return (
    <Card variant="outlined" style={{ border: "1px solid grey" }}>
      <div className={classes.cardTitle}>
        {icon}
        <Typography variant="h5" className={classes.cardTitleText}>
          {title}
        </Typography>
      </div>
      <CardContent>
        <Typography variant="body1" align="center">{data}</Typography>
        {button && (
            <div style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                <Button variant="contained" color="secondary">Join Chat</Button>
            </div>
        )}
      </CardContent>
    </Card>
  );
}
